export const TOGGLE_SIDEBAR_COLLAPSED = 'settings/TOGGLE_SIDEBAR_COLLAPSED'
export const SET_DISPATCHES_VIEW = 'settings/SET_DISPATCHES_VIEW'

let initialState = {
  sideBarCollapsed: false,
  dispatchesView: 'table',
}

const storageValues = [
  { name: 'dispatchesView', parse: false },
]

storageValues.forEach(i => {
  const localValue = localStorage.getItem(i.name)

  if (localValue) {
    initialState[i.name] = i.parse ? JSON.parse(localValue) : localValue
  }
})

export default (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_SIDEBAR_COLLAPSED:
      return {
        ...state,
        sideBarCollapsed: !state.sideBarCollapsed
      }

    case SET_DISPATCHES_VIEW:
      localStorage.setItem('dispatchesView', action.dispatchesView)

      return {
        ...state,
        dispatchesView: action.dispatchesView
      }

    default:
      return state
  }
}

export const toggleSideBarCollapsed = () => {
  return dispatch => {
    dispatch({
      type: TOGGLE_SIDEBAR_COLLAPSED
    })
  }
}

export const setDispatchesView = (dispatchesView) => {
  return dispatch => {
    dispatch({
      type: SET_DISPATCHES_VIEW,
      dispatchesView
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/settings.js